var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.988,6L14,6C14.552,6,15,6.406,15,6.909L15,15.091C15,15.594,14.552,16,14,16L2,16C1.448,16,1,15.594,1,15.091L1,6.909C1,6.406,1.448,6,2,6L10.984,6L11,5C11,3.346,9.654,2,8,2C6.915,2,5.978,2.587,5.452,3.453L4.0120000000000005,2.013C4.9239999999999995,0.797,6.363,0,8,0C10.761,0,13,2.238,13,5L12.988,6ZM13,8L13,14L3,14L3,8L13,8Z",
    fillRule: "evenodd",
    fill: "#FFFFFF",
    fillOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.1a63d1967374f1e5e938c92f5542a6fe.svg";
export { ForwardRef as ReactComponent };